import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '@app/shared/services/inventory.service';

@Component({
  selector: 'app-inventory-listii',
  templateUrl: './inventory-listii.component.html',
  styleUrls: ['./inventory-listii.component.css']
})
export class InventoryListiiComponent implements OnInit {


  inventoryMaterials: any[] = [];
  totalBalance: number = 0;
  totalInput: number = 0;
  totalOutput: number = 0;
  codePrefix : string = '30';
  descriptionPrefix: string = 'RAW MATERIALS';
  selectedCategory: string;
  subcategories: string[] = [];

  constructor(
    private acRoute: ActivatedRoute,
    private inventoryService: InventoryService,
    private cdr: ChangeDetectorRef, // Inject ChangeDetectorRef
    private router: Router // Inject Router

  ) { }

  ngOnInit(): void {
    this.acRoute.queryParams.subscribe(params => {
      this.selectedCategory = params['category'];
      console.log(this.selectedCategory);
      // Call a function to fetch subcategories based on the selected category
      this.fetchSubcategories(this.selectedCategory);
       // Manually trigger change detection
       this.cdr.detectChanges();
    });
  
  }

  fetchSubcategories(selectedCategory: string) {
    this.inventoryService.getAllInventry().subscribe(
      (data: any[]) => {
        // Assign data to inventoryMaterials
        this.inventoryMaterials = data;
        // Extract unique subcategories for the selected category
        this.subcategories = this.extractUniqueSubcategories(data, selectedCategory);
        // Manually trigger change detection
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error fetching inventory materials:', error);
      }
    );
  }
  
  extractUniqueSubcategories(data: any[], selectedCategory: string): string[] {
    const subcategories: string[] = [];
    data.forEach(item => {
      if (item.category === selectedCategory && !subcategories.includes(item.subcategory)) {
        subcategories.push(item.subcategory);
      }
    });
    return subcategories.sort();
  }
  

  calculateTotalInput(SubcategoryOrMaterial: string): number {
    return this.inventoryMaterials
      .filter(item => item.subcategory === SubcategoryOrMaterial || item.subcategory === SubcategoryOrMaterial)
      .reduce((acc, item) => acc + (item.qty || 0), 0);
  }

  calculateTotalOutput(SubcategoryOrMaterial: string): number {
    return this.inventoryMaterials
      .filter(item => item.subcategory === SubcategoryOrMaterial || item.subcategory === SubcategoryOrMaterial)
      .reduce((acc, item) => acc + (item.output || 0), 0);
  }

  calculateTotalBalance(SubcategoryOrMaterial: string): number {
    const totalInput = this.calculateTotalInput(SubcategoryOrMaterial);
    const totalOutput = this.calculateTotalOutput(SubcategoryOrMaterial);
    return totalInput - totalOutput;
  }

  viewDetails(subcategory: string) {
    // Perform action for viewing details of the specified subcategory
    console.log('Viewing details of subcategory:', subcategory);
  }
  

onNextButtonClick(subcategory: string) {
  // Perform action for the next button click for the specified category
  console.log('Next button clicked for subcategory:', subcategory);
  // Navigate to the next component and pass the selected category as a parameter
  this.router.navigate(['/inventoryiii'], { queryParams: { subCategory: subcategory } });
}

 
}
